import { ArrowDown, ArrowUp } from 'lucide-react';

/**
 * Period-over-period change indicator. Up is treated as positive (green).
 * Shared by the KPI strip and the feature leaderboard.
 */
export function DeltaBadge({
  delta,
  format,
  className = '',
  label = 'vs prev',
}: {
  delta: number;
  format?: (n: number) => string;
  className?: string;
  /** Trailing context, e.g. "vs prev" (default) or "in period". */
  label?: string;
}) {
  const fmt = format ?? ((n: number) => `${n > 0 ? '+' : ''}${n}`);
  if (delta === 0) {
    return <div className={`text-xs text-muted-foreground ${className}`}>No change {label}</div>;
  }
  const up = delta > 0;
  const Icon = up ? ArrowUp : ArrowDown;
  return (
    <div
      className={`flex items-center gap-0.5 text-xs font-medium ${up ? 'text-success-600' : 'text-error-600'} ${className}`}
    >
      <Icon className="h-3 w-3" />
      <span>{fmt(delta)}</span>
      <span className="ml-0.5 font-normal text-muted-foreground">{label}</span>
    </div>
  );
}
